import {Pipe, PipeTransform} from '@angular/core';
import {RouteService} from '../services/route.service';

@Pipe({
    name: 'stopTitle'
})
export class StopTitlePipe implements PipeTransform {
    constructor(private routeService: RouteService) {
    }

    transform(id: number): any {
        const stops = this.routeService.getStop();
        return stops.find((el) => el.id === id).title;
    }
}
